export default __webpack_public_path__ + "static/6906-9c8fd09c39185c1b92e0ddc10920be1f.jpg";